import { Routes } from '@angular/router';
import { MainLayoutComponent } from './main-layout.component';
import { DashboardComponent } from './dashboard.component';
import { ScheduleComponent } from './schedule.component';
import { InventoryComponent } from './inventory.component';
import { PurchaseOrdersComponent } from './purchase-orders.component';
import { PurchaseOrderDetailComponent } from './purchase-order-detail.component';
import { ProfileComponent } from './profile.component';
import { JobExecutionComponent } from './job-execution.component';
import { FieldQuotingComponent } from './field-quoting.component';
import { LoginComponent } from './login.component';
import { ActivateComponent } from './activate.component';
import { ForgotPasswordComponent } from './forgot-password.component';
import { ResetPasswordComponent } from './reset-password.component';
import { JobPhotosComponent } from './job-photos.component';
import { JobNotesComponent } from './job-notes.component';
import { JobMaterialsComponent } from './job-materials.component';
import { CreateJobComponent } from './create-job.component';
import { ProjectExecutionComponent } from './project-execution.component';
import { WorkListComponent } from './work-list.component';
import { MobileAsBuiltEditorComponent } from './mobile-as-built-editor.component';
import { NotificationsComponent } from './notifications.component';
import { authGuard, drainlayerGuard, guestGuard } from './auth.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [guestGuard] },
  { path: 'activate', component: ActivateComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent }, 
  { path: 'reset-password', component: ResetPasswordComponent },
  { 
    path: '', 
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: DashboardComponent },
      { path: 'schedule', component: ScheduleComponent },
      { path: 'inventory', component: InventoryComponent },
      { path: 'purchase-orders', component: PurchaseOrdersComponent },
      { path: 'purchase-orders/new', component: PurchaseOrderDetailComponent },
      { path: 'purchase-orders/:id', component: PurchaseOrderDetailComponent },
      {
        path: 'leave-requests',
        loadComponent: () => import('./leave-requests.component').then(module => module.LeaveRequestsComponent)
      },
      {
        path: 'leave-requests/:id',
        loadComponent: () => import('./leave-request-detail.component').then(module => module.LeaveRequestDetailComponent)
      },
      { path: 'profile', component: ProfileComponent },
      { path: 'notifications', component: NotificationsComponent },
      {
        path: 'google-review-qr',
        loadComponent: () => import('./google-review-qr.component').then(module => module.GoogleReviewQrComponent)
      },
      { path: 'create-job', component: CreateJobComponent },
      { path: 'work-list/:kind', component: WorkListComponent },
      {
        path: 'as-built',
        canActivate: [drainlayerGuard],
        loadComponent: () => import('./as-built-dashboard.component').then(module => module.AsBuiltDashboardComponent)
      },
    ]
  },
  { path: 'job/:id', component: JobExecutionComponent, canActivate: [authGuard] },
  { path: 'job/:id/photos', component: JobPhotosComponent, canActivate: [authGuard] },
  { path: 'job/:id/notes', component: JobNotesComponent, canActivate: [authGuard] },
  { path: 'job/:id/materials', component: JobMaterialsComponent, canActivate: [authGuard] },
  { path: 'job/:id/quote', component: FieldQuotingComponent, canActivate: [authGuard] },
  { path: 'project/:id', component: ProjectExecutionComponent, canActivate: [authGuard] },
  { path: 'as-built/:id', component: MobileAsBuiltEditorComponent, canActivate: [authGuard] },
];
